////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const rolesManager = {
	getRoles: (userMode) => ({
		type: ActionsTypes.GET_ROLES,
		payload: { userMode },
	}),
	getRolesSuccess: (roles) => ({
		type: ActionsTypes.GET_ROLES_SUCCESS,
		payload: {
			roles,
		},
	}),
	getRolesFailure: (error) => ({
		type: ActionsTypes.GET_ROLES_FAILURE,
		payload: {
			error,
		},
	}),
	createRole: (role) => ({
		type: ActionsTypes.CREATE_ROLE,
		payload: {
			role,
		},
	}),
	createRoleSuccess: (role) => ({
		type: ActionsTypes.CREATE_ROLE_SUCCESS,
		payload: {
			role,
		},
	}),
	createRoleFailure: (error) => ({
		type: ActionsTypes.CREATE_ROLE_FAILURE,
		payload: {
			error,
		},
	}),
	deleteRole: (idRole, scope, redirectRequest = false) => ({
		type: ActionsTypes.DELETE_ROLE,
		payload: {
			idRole,
			scope,
			redirectRequest,
		},
	}),
	deleteRoleSuccess: (idRole) => ({
		type: ActionsTypes.DELETE_ROLE_SUCCESS,
		payload: {
			idRole,
		},
	}),
	deleteRoleFailure: (error) => ({
		type: ActionsTypes.DELETE_ROLE_FAILURE,
		payload: {
			error,
		},
	}),
	getRoleDetail: (idRole) => ({
		type: ActionsTypes.GET_ROLE_DETAIL,
		payload: { idRole },
	}),
	getRoleDetailSuccess: (roleDetail) => ({
		type: ActionsTypes.GET_ROLE_DETAIL_SUCCESS,
		payload: {
			roleDetail,
		},
	}),
	getRoleDetailFailure: (error) => ({
		type: ActionsTypes.GET_ROLE_DETAIL_FAILURE,
		payload: {
			error,
		},
	}),
	updateHeaderRole: (idRole, role) => ({
		type: ActionsTypes.UPDATE_HEADER_ROLE,
		payload: {
			idRole,
			role,
		},
	}),
	updateHeaderRoleSuccess: (role) => ({
		type: ActionsTypes.UPDATE_HEADER_ROLE_SUCCESS,
		payload: {
			role,
		},
	}),
	updateHeaderRoleFailure: (error) => ({
		type: ActionsTypes.UPDATE_HEADER_ROLE_FAILURE,
		payload: {
			error,
		},
	}),
	updateContentRole: (idRole, datas) => ({
		type: ActionsTypes.UPDATE_CONTENT_ROLE,
		payload: {
			idRole,
			datas,
		},
	}),
	updateContentRoleSuccess: (role) => ({
		type: ActionsTypes.UPDATE_CONTENT_ROLE_SUCCESS,
		payload: {
			role,
		},
	}),
	updateContentRoleFailure: (error) => ({
		type: ActionsTypes.UPDATE_CONTENT_ROLE_FAILURE,
		payload: {
			error,
		},
	}),
	resetRole: () => ({
		type: ActionsTypes.RESET_ROLE,
	}),
}

export default rolesManager
